import { FormField, FormControl, FormItem, FormLabel } from "../ui/form";
import {
  Select,
  SelectContent,
  SelectTrigger,
  SelectItem,
  SelectValue,
} from "../ui/select";
import { UseFormReturn, Path } from "react-hook-form";

export default function FormSelect<TFieldValues extends Record<string, unknown>>({
  id,
  label,
  options,
  form,
}: {
  id: Path<TFieldValues>;
  label: string;
  options: { label: string; value: string }[];
  form: UseFormReturn<TFieldValues>;
}) {
  return (
    <FormField
      control={form.control}
      name={id}
      render={({ field }) => (
        <FormItem>
          <FormLabel className="">{label}</FormLabel>
          <Select onValueChange={field.onChange} defaultValue={field.value as string | undefined}>
            <FormControl>
              <SelectTrigger className="min-w-[200px]">
                <SelectValue placeholder="Select an option" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {options.map((option) => (
                <SelectItem value={option.value} key={option.value} className="w-full">
                  {option.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        </FormItem>
      )}
    />
  );
}
